import React from 'react';

export default function Account() {
  return (
    <>
      <h1 className="wp-portal__page-title">Account</h1>
      <p className="wp-portal__page-sub">Your account information and settings.</p>
      <div className="wp-portal__empty">
        <p className="wp-portal__empty-label">
          Account details will appear here once your profile has been
          configured by Woss Publishing.
        </p>
      </div>
    </>
  );
}
